webpackJsonp([14],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENV */
/* unused harmony export server */
/* unused harmony export host */
/* unused harmony export passportHost */
var serverConfigs = __webpack_require__(8);
var ENV = "prod_na";
var server = serverConfigs[ENV];

var host = server.host;
var passportHost = server.passportHost;

/* harmony default export */ __webpack_exports__["a"] = ({
  host: server.host,
  passportHost: server.passportHost,
  env: ENV,
  APP_KEY: 'CZUR_PASSPORT_WEB',
  CHANNEL: 'ALL',
  DEFAULT_PAGE: 'basic.html',
  HTTP_HEADER_KEY: {
    APP_KEY: 'App-Key',
    UDID: 'udid',
    CHANNEL: 'Channel',
    TOKEN: 'T-ID',
    USERID: 'U-ID'
  },
  COOKIE_KEY: {
    U_ID: 'U-ID',
    TOKEN: 'T-ID',
    USER_NAME: 'user',
    LANG: 'lang'
  },
  CALL_BACK: '',
  R_CODE: {
    SUCCESS: 1000,
    INTERNAL_ERROR: 1001,
    INVALID_TOKEN: 1002,
    BAD_ACCESS: 1003,
    PWD_ERROR: 1004,
    USER_INACTIVE: 1005,
    CHANNEL_UNSUPPORT: 1006,
    INVALID_MOBILE: 1007,
    INVALID_EMAIL: 1008,
    SMS_MANY_REQUEST: 1009,
    SMS_SEND_10S: 1010,
    USER_EXIST: 1011,
    MAIL_MANY_REQUEST: 1012,
    MAIL_SEND_10S: 1013,
    INVALID_CODE: 1014,
    IMG_PRO_ERROR: 1015,
    IMG_PRO_ING: 1016,
    INVALID_USER_NAME: 1017,
    USER_NO_EXIST: 1018,
    TIME_OUT: 1019,
    IMG_NOT_FOUND: 1020,
    DEVICE_OCCUPIED: 1021,
    USER_USING_DEVICE: 1022,
    MANY_REQUEST_CODE: 1023,
    PWD_OLD_SAME: 1030,
    PWD_OLD_ERROR: 1031,
    NO_MOBILE_BIND: 1032,
    CODE_ERROR: 1033,
    MOBILE_USED_OTHERS: 1034,
    EMAIL_USED_OTHERS: 1035
  },
  getChannel: function getChannel() {
    var channel = this.getReqParam('Channel');
    if (!channel) {
      channel = this.CHANNEL;
    }
    return channel;
  },
  cookieSet: function cookieSet(key, value) {
    var Days = 30;
    var date = new Date();
    date.setTime(date.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + escape(value) + '; path=/;expires = ' + date.toGMTString();
  },
  cookieGet: function cookieGet(key) {
    var result;
    var mycookie = document.cookie;
    var start2 = mycookie.indexOf(key + '=');
    if (start2 > -1) {
      var start = mycookie.indexOf('=', start2) + 1;
      var end = mycookie.indexOf(';', start);
      if (end === -1) {
        end = mycookie.length;
      }
      result = unescape(mycookie.substring(start, end));
    }
    return result;
  },
  getReqParam: function getReqParam(param) {
    var url = window.location.search;
    var theRequest = {};
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1);
      var strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
      }
    }
    return theRequest[param];
  },
  appendParam: function appendParam(url, param, value) {
    var archor = '';
    if (url.indexOf('#') > 0) {
      var strs = url.split('#');
      url = strs[0];
      archor = strs[1];
    }
    if (url.indexOf('?') >= 0) {
      url = url + '&';
    } else {
      url = url + '?';
    }
    url = url + param + '=' + encodeURIComponent(value);
    if (archor !== '') {
      url = url + '#' + archor;
    }
    return url;
  },
  getLocalStore: function getLocalStore(key) {
    return localStorage.getItem(key);
  },
  setLocalStore: function setLocalStore(key, value) {
    localStorage.setItem(key, value);
  },
  lang: function lang() {
    var requestLang = this.getReqParam('lang');
    var currentLang = this.cookieGet('lang');
    if (requestLang !== undefined && requestLang !== '' && requestLang !== currentLang) {
      currentLang = requestLang;
      this.cookieSet('lang', currentLang);
    }
    if (!currentLang) {
      currentLang = navigator.language;
      if (!currentLang) {
        currentLang = navigator.browserLanguage;
      }
    }
    if (currentLang !== 'en' && currentLang !== 'zh-CN' && currentLang !== 'zh-TW' && currentLang !== 'ru_RU') {
      currentLang = 'en';
    }
    return currentLang;
  },
  local4Service: function local4Service() {
    var lang = this.lang();
    var local = lang.replace('-', '_');
    return local;
  },
  urlRemoveParam: function urlRemoveParam(param) {
    var url = window.location.href;
    if (window.location.search.indexOf(param[0]) >= 0) {
      var hosturl = url.replace(window.location.search, '').replace(window.location.hash, '');
      var params = window.location.search.substr(1);
      var strs = params.split('&');
      for (var m = 0; m < param.length; m++) {
        var one = param[m];
        for (var i = 0; i < strs.length; i++) {
          if (strs[i].indexOf(one) >= 0) {
            strs.splice(i, 1);
            break;
          }
        }
      }
      if (strs.length > 0) {
        var search = strs.join('&');
        hosturl = hosturl + '?' + search;
      }
      url = hosturl + window.location.hash;
    }
    return url;
  }
});

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(451)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/privacy/privacy.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] privacy.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-18d0c175", Component.options)
  } else {
    hotAPI.reload("data-v-18d0c175", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacy_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__privacy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__ = __webpack_require__(0);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.APP_KEY] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].APP_KEY;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.CHANNEL] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].getChannel();

  next(function (response) {
    return response;
  });
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = el.dataset.title;
  },
  update: function update(el, binding) {
    document.title = el.dataset.title;
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__privacy_vue___default.a);
  }
}).$mount('#privacy');

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__privacy_CZUR_privacy_CZUR_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__privacy_CZUR_privacy_CZUR_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__privacy_CZUR_privacy_CZUR_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacy',
  data: function data() {
    return {};
  },

  components: {
    privacyCZUR: __WEBPACK_IMPORTED_MODULE_0__privacy_CZUR_privacy_CZUR_vue___default.a
  }
});

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacy {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacy h1 {\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacy div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacy div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacy div a {\n  color: #000;\n}\n#privacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

var docEl = document.documentElement;
var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
var remSize = 100;
var recalc = function recalc() {
  var clientWidth = docEl.clientWidth;
  if (!clientWidth) {
    return;
  }
  if (clientWidth <= 720) {
    docEl.style.fontSize = remSize * (clientWidth / 500) + 'px';
  } else {
    docEl.style.fontSize = remSize + 'px';
  }
};

if (document.addEventListener) {
  window.addEventListener(resizeEvt, recalc, false);
  document.addEventListener('DOMContentLoaded', recalc, false);
}

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    staticClass: "body-content"
  }, [_c('privacyCZUR')], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-18d0c175", module.exports)
  }
}

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(351);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7567a22e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-18d0c175\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-18d0c175\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(69)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(66),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/privacy_CZUR/privacy_CZUR.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] privacy_CZUR.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-76cde9fa", Component.options)
  } else {
    hotAPI.reload("data-v-76cde9fa", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacy',
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  }
});

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacy {\n  margin: 0.25rem;\n  font-size: 0.18rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacy h1 {\n  margin-top: 0.5rem;\n  font-weight: bold;\n  font-size: 0.2rem;\n}\n#privacy div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.2rem;\n}\n#privacy div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacy div a {\n  color: #000;\n}\n#privacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('h1', [_vm._v("隐私政策")]), _vm._v(" "), _c('div', [_vm._v("最近更新：2022年8月8日")]), _vm._v(" "), _c('div', [_vm._v("请花一些时间熟悉我们的隐私政策，如果您有任何问题，请联系我们。")]), _vm._v(" "), _c('div', [_vm._v("大连成者科技有限公司及旗下各关联公司（以下统称“成者科技”）尊重并保护所有使用产品（包含：“成者CZUR”、“极简扫描”、“成者极简扫描”、“CZUR”等相关APP）或服务用户的个人隐私权。为了给您提供产品或服务，成者科技会按照本隐私权政策的规定使用和披露您的个人信息。但成者科技将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，成者科技不会将这些信息对外披露或向第三方提供。")]), _vm._v(" "), _c('div', [_vm._v("您在同意成者科技服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于成者科技服务使用协议不可分割的一部分，成者科技会不时更新本隐私权政策，请您关注。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("1、 我们收集哪些信息以及信息用途")]), _vm._v(" "), _c('div', [_vm._v("在您使用我们的产品或服务时，我们可能需要收集和使用的您的个人信息包括如下两种：")]), _vm._v(" "), _c('div', [_vm._v("a）为实现向您提供我们产品或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品或服务；")]), _vm._v(" "), _c('div', [_vm._v("b）为实现向您提供我们产品或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品或服务的基本功能。")]), _vm._v(" "), _c('div', [_vm._v("1）您须授权我们收集和使用您个人信息的情形")]), _vm._v(" "), _c('div', [_vm._v("a）在您使用我们产品或服务过程中，为识别账号异常状态、安全地连接和管理智能硬件、智能硬件的异常状态、了解或优化相关产品适配性、向您提供更契合您需求的页面展示和搜索结果，我们可能会自动收集您的使用情况并存储为网络日志信息；我们可能会收集您的Wi-Fi信息、IP地址、位置信息、登录帐号信息、手机相关信息、智能设备相关信息，以及帐号和智能设备的关联信息。上述各项信息，详细列举如下：")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 成者科技登录帐号信息：帐号、昵称、头像信息。")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 手机相关信息：硬件设备标识(设备硬件序列号、Mac地址、Android ID)、系统版本信息、系统语言。")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 通过Wi-Fi或蓝牙连接的智能硬件设备：Wi-Fi信息（SSID,BSSID, Wi-Fi的Mac地址、Wi-Fi密码）、设备蓝牙Mac地址、设备ID、设备系统版本信息、系统语言、系统使用设置")]), _vm._v(" "), _c('div', [_vm._v("b）为了使您持续享受最新的服务，我们可能会使用您的“成者CZUR”应用的版本信息。同时，我们可能收集您已连接的智能设备列表和版本号信息，用于为您提供智能设备的升级功能，以确保您可以使用最新版本的服务（包括固件版本）。")]), _vm._v(" "), _c('div', [_vm._v("2）您可选择是否授权我们收集和使用您的个人信息的情形")]), _vm._v(" "), _c('div', [_vm._v("为使您更好的体验智能硬件设备的使用、控制、管理等，我们的以下附加功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以使用基础服务，但您可能无法使用这些可以为您所带来便利的附加功能。这些附加功能包括：")]), _vm._v(" "), _c('div', [_vm._v("a）人脸识别管理")]), _vm._v(" "), _c('div', [_vm._v("如果您通过“成者CZUR”连接了支持人脸识别功能的特定产品（如“明镜Mirror” 智能坐姿仪系列、“Auramate” 智能陪伴仪系列等产品），您可以录入人脸及坐姿图像进行更好的智能设备使用体验（识别自定义姿势、识别有人使用设备的报告）。您可以录入需要识别的人脸素材，您可以在对应的产品功能里来添加和删除人脸及坐姿图像。 如果您对我们识别的结果有疑问，您可以和我们反馈以帮助我们优化算法和模型。在此情况下，我们会收集您主动反馈的问题的图文信息。请您放心，您反馈的信息仅会用于优化算法和模型，不会用于其他用途。")]), _vm._v(" "), _c('div', [_vm._v("b） 用户反馈：")]), _vm._v(" "), _c('div', [_vm._v("我们可能收集您发给我们的反馈的问题、反馈日志，以及您填写的电话号码或邮箱，这些信息将用于让我们更好的了解您遇到的问题，以及联系您。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("2. 信息披露")]), _vm._v(" "), _c('div', [_vm._v("在如下情况下，成者科技将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：")]), _vm._v(" "), _c('div', [_vm._v("a) 经您事先同意，向第三方披露；")]), _vm._v(" "), _c('div', [_vm._v("b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；")]), _vm._v(" "), _c('div', [_vm._v("c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；")]), _vm._v(" "), _c('div', [_vm._v("d) 如您出现违反当地国家有关法律、法规或者成者科技服务协议或相关规则的情况，需要向第三方披露；")]), _vm._v(" "), _c('div', [_vm._v("e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；")]), _vm._v(" "), _c('div', [_vm._v("f) 在成者科技平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，成者科技有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。")]), _vm._v(" "), _c('div', [_vm._v("g) 其它成者科技根据法律、法规或者网站政策认为合适的披露。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("3. 征得授权同意的例外")]), _vm._v(" "), _c('div', [_vm._v("根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：")]), _vm._v(" "), _c('div', [_vm._v("a）与国家安全、国防安全有关的；")]), _vm._v(" "), _c('div', [_vm._v("b）与公共安全、公共卫生、重大公共利益有关的；")]), _vm._v(" "), _c('div', [_vm._v("c）与犯罪侦查、起诉、审判和判决执行等有关的；")]), _vm._v(" "), _c('div', [_vm._v("d）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；")]), _vm._v(" "), _c('div', [_vm._v("e）所收集的信息是您自行向社会公众公开的；")]), _vm._v(" "), _c('div', [_vm._v("f）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；")]), _vm._v(" "), _c('div', [_vm._v("g）根据您的要求签订合同所必需的；")]), _vm._v(" "), _c('div', [_vm._v("h）用于维护成者科技服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；")]), _vm._v(" "), _c('div', [_vm._v("i）为合法的新闻报道所必需的；")]), _vm._v(" "), _c('div', [_vm._v("j）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；")]), _vm._v(" "), _c('div', [_vm._v("k）法律法规规定的其他情形。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("4. 信息存储和交换")]), _vm._v(" "), _c('div', [_vm._v("成者科技收集的有关您的信息和资料将保存在成者科技及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或成者科技收集信息和资料所在地的境外并在境外被访问、存储和展示。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("5. Cookie的使用")]), _vm._v(" "), _c('div', [_vm._v("a) 在您未拒绝接受cookies的情况下，成者科技会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的成者科技平台服务或功能。")]), _vm._v(" "), _c('div', [_vm._v("b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的成者科技网络服务或功能。")]), _vm._v(" "), _c('div', [_vm._v("c) 通过成者科技所设cookies所取得的有关信息，将适用本政策。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("6、 信息安全")]), _vm._v(" "), _c('div', [_vm._v("a) 成者科技帐号均有安全保护功能，请妥善保管您的用户名及密码信息。成者科技将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。")]), _vm._v(" "), _c('div', [_vm._v("b) 在使成者科技网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是成者科技用户名及密码发生泄露，请您立即联络成者科技客服，以便成者科技采取相应措施。")]), _vm._v(" "), _c('div', [_vm._v("c) 成者科技不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和成者科技（含成者科技关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。")]), _vm._v(" "), _c('div', [_vm._v("d) 成者科技亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何成者科技平台用户如从事上述活动，一经发现，成者科技有权立即终止与该用户的服务协议。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("7. 软件隐私权限说明")]), _vm._v(" "), _c('div', [_vm._v("a) 显示弹框、全屏界面到其他应用上面。")]), _vm._v(" "), _c('div', [_vm._v("b) 允许应用修改或删除存储卡上的照片、媒体内容和文件。")]), _vm._v(" "), _c('div', [_vm._v("c) 允许应用基于GPS、基站、 Wi-Fi 等网络源获取位置信息。这可能会增加耗电量。")]), _vm._v(" "), _c('div', [_vm._v("d) 允许应用在后台运行时检索用户位置信息。")]), _vm._v(" "), _c('div', [_vm._v("e) 允许应用录制音频。")]), _vm._v(" "), _c('div', [_vm._v("f) 允许应用拍摄照片和视频。")]), _vm._v(" "), _c('div', [_vm._v("g) 允许应用读取存储卡上的照片、媒体内容和文件。")]), _vm._v(" "), _c('div', [_vm._v("h) 允许应用获取本机号码、通话状态以及拨打的号码。")]), _vm._v(" "), _c('div', [_vm._v("i) 修改设置应用中的设置项。")]), _vm._v(" "), _c('div', [_vm._v("j) 允许应用打开蓝牙权限，连接ble蓝牙设备。")]), _vm._v(" "), _c('div', [_vm._v("k) 为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("8. 第三方服务收集的信息和安全保障功能")]), _vm._v(" "), _c('div', [_vm._v("a)com.tencent.bugly(Bugly;腾讯Bugly)；收集信息：需要网络权限和存储权限，搜集brand、model等基本设备信息；使用目的：提供异常日志分析服务；收集方式：SDK对手机进行本地采集")]), _vm._v(" "), _c('div', [_vm._v("b) com.huawei.hms(华为;华为推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("c) com.sina.weibo(微博;新浪微博)；收集信息：设备信息；使用目的：用于分享，第三方登录；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("d) com.umeng(友盟)；收集信息：设备信息，用户的IMSI信息； 使用目的：用于第三方（微信、QQ）共享登录，分享；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("e) com.huawei.agconnect(华为;华为联运应用)；收集信息：设备信息；使用目的：华为应用市场分发服务；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("f) cn.jpush.android(极光;极光推送)；收集信息：设备信息、地理位置、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("g)com.tencent.mm(微信)；收集信息：MAC地址、唯一设备识别码；使用目的：购买VIP服务等；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("h)com.eg.android.AlipayGphone(支付宝)；收集信息：设备信息（如IMEI、IMSI、SIM卡序列号、MAC地址、AndroidID、SSID、BSSID、设备基础信息【机型\\厂商等】）、网络信息；使用目的：购买VIP服务等；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("i) com.xiaomi.mipush(小米;小米推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("j) com.heytap.mcs(OPPO;OPPO推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("k) com.vivo.push(VIVO;VIVO推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("l) io.agora(声网) ；收集信息：设备类型、设备型号、CPU信息、电池电量信息、操作系统信息收发端用户ID、用户属性、频道信息、使用时长、频道内设置名称、日志；使用目的：提供视频与音频会议功能；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("9. 适用于某些国家/地区的特别规定")]), _vm._v(" "), _c('div', [_vm._v("在中国（为本条款之目的，不包含港澳台地区）运营中收集和产生的个人信息遵守《中华人民共和国网络安全法》关于关键信息基础设施个人信息和重要业务数据出境的相关规定。 在中国香港特别行政区、澳门特别行政区和台湾地区，我们的产品和服务将遵守包括《香港个人资料（私隐）条例》在内的该等各地区的可适用法律规范的要求。")]), _vm._v(" "), _c('div', [_vm._v("在《欧盟通用数据保护条例》（EU General Data Protection Regulation）对我们提供的服务可适用的情形下，我们承诺，您同时享有该条例项下的相关权益，包括但不限于数据访问权（您可以从我们处获得关于是否正在处理与您有关的个人数据、处理地点以及处理目的的确认等）、数据迁移权（在有关条件下，依照您的请求，我们将向您提供符合该条例规定的形式的您的数据，或向指定的其他数据控制者传输您的数据）、被遗忘权（在有关条件下，依照您的请求，我们将无不当延误地删除所有有关您的个人数据）。")]), _vm._v(" "), _c('div', [_vm._v("在美国，我们的产品和服务将遵守包括美国《隐私权法案》（Privacy Act）、《电子通信隐私法案》（Electronic Communications Privacy Act）、《儿童在线隐私保护法案》（Children's Online Privacy Protection Act）在内的可适用法律规范的要求。")]), _vm._v(" "), _c('div', [_vm._v("如果可适用法律规范所规定的您的有关权益与本《隐私政策》的内容有不符之处，以该可适用法律规范的规定为准，但前述可适用法律规范的规定如与本《隐私政策》约定的适用法律的强制性规定有冲突处，我们将在优先遵守该等强制性规定的前提下，尽可能遵守该可适用法律规范的规定。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("10. 通知和修订")]), _vm._v(" "), _c('div', [_vm._v("我们可能适时修改本《隐私政策》的条款，该等修改构成本《隐私政策》的一部分。对于重大变更，我们会提供更显著的通知，您可以选择停止使用成者科技服务；在该种情况下，如您仍然继续使用成者科技服务的，即表示同意受经修订的本《隐私政策》的约束。")]), _vm._v(" "), _c('div', [_vm._v("任何修改都会将您的满意度置于首位。我们鼓励您在每次使用成者科技服务时都查阅我们的隐私政策。")]), _vm._v(" "), _c('div', [_vm._v("我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。")]), _vm._v(" "), _c('div', [_vm._v("最后，您必须对您的账号和密码信息负有保密义务。任何情况下，请小心妥善保管。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("11. 注销服务或帐号")]), _vm._v(" "), _c('div', [_vm._v("如您需要注销您的成者帐号，您可以在【我的-用户协议和隐私政策-注销账号】提交注销申请，并根据提示进行注销流程。由于注销成者帐号的操作将使您无法使用成者产品和服务，请您谨慎操作。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("12. 如何联系我们")]), _vm._v(" "), _c('div', [_vm._v("如您有关于网络信息安全的投诉和举报，或您对本《隐私政策》、您的信息的相关事宜有任何问题、意见或建议，以及有关本声明或成者科技的隐私措施的问题请与成者科技的协调人联系。")]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("查看详细说明也可访问 "), _c('a', {
    attrs: {
      "href": "https://passport.czur.cc/3dsharelist.html"
    }
  }, [_vm._v("https://passport.czur.cc/3dsharelist.html")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("电子邮箱： "), _c('a', {
    attrs: {
      "href": "mailto:service@czur.com"
    }
  }, [_vm._v("service@czur.com")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-76cde9fa", module.exports)
  }
}

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(61);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e0b88fb0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-76cde9fa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_CZUR.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-76cde9fa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_CZUR.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  test: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  test_na: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  prod: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  },
  prod_na: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  }
};

/***/ })

},[261]);


// WEBPACK FOOTER //
// static/js/module/privacy.81e06c32e74124fb08d4.js